import type { WatchQueryFetchPolicy } from "@apollo/client";
import {
  GetRenewalListItemsQueryVariables,
  useGetRenewalListItemsQuery as useGetRenewalListItemsBaseQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting Renewal list items based on the user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - renewals list, total count, error and loading state.
 */
export function useGetRenewalListItemsQuery(
  variables: GetRenewalListItemsQueryVariables
) {
  const queryOptions: {
    fetchPolicy: WatchQueryFetchPolicy;
    variables: GetRenewalListItemsQueryVariables;
  } = { fetchPolicy: "cache-and-network", variables };

  const { data, error, loading, previousData } =
    useGetRenewalListItemsBaseQuery(queryOptions);

  return {
    error,
    loading: loading && !data,
    renewals: data?.getRenewalListItems.items ?? [],
    totalCount:
      data?.getRenewalListItems.pagination.total ??
      previousData?.getRenewalListItems.pagination.total ??
      0,
  };
}
